// extracted by mini-css-extract-plugin
export default {"div":"LillButton_div__-gAcg","btn":"LillButton_btn__QWS9R","Tem":"LillButton_Tem__jD8ji","Ntem":"LillButton_Ntem__8Gub3"};